import React from "react";
import { Row, Col } from "react-bootstrap";
import { Container } from "@material-ui/core";
import Network from "../../images/global-network.svg";

export default function AgribusinessType({ types, title, description, md }) {
  return (
    <Container className=" for-farmer-section2 subSectionWrapper ">
      {/* <h2 className="text-center title mb-4 mb-lg-5 container-title">
        Explore ABN
      </h2> */}
      <h2 className="container-title text-center ">{title}</h2>
      {description && <p className="text-center">{description}</p>}
      <Row className="justify-content-center">
        {types.map((type, index) => {
          return (
            <Col md={md} sm={6} key={index}>
              <div className="rounded network-type-cards border rounded-lg p-3 text-center mb-2 d-flex align-items-center">
                <img src={Network} alt="Network" />
                <p className="d-inline-block ms-3 mb-0">{type}</p>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}
